var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPillGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Stroke-10186 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sections/Sidebar",
    transform: "translate(-21.000000, -175.000000)",
    stroke: "#7F7F7F"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "navigation",
    transform: "translate(0.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nav-item",
    transform: "translate(0.000000, 132.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8106093,28.4877419 C28.7942652,30.504086 25.5277419,30.504086 23.5113978,28.4877419 C21.4962007,26.4725448 21.4962007,23.2048746 23.5113978,21.1885305 L29.1888172,15.5122581 C31.2040143,13.495914 34.4716846,13.495914 36.4868817,15.5122581 C38.5032258,17.5274552 38.5032258,20.7951254 36.4868817,22.8114695 L30.8106093,28.4877419 Z M26.3494194,18.3506237 L33.6486308,25.6498351 M30.4051613,18.1944414 L30.8111828,17.7884199 C31.9306093,16.6701403 33.7450896,16.6701403 34.8656631,17.7884199",
    id: "Stroke-10186-2"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPillGrey);
export default __webpack_public_path__ + "static/media/icon-pill-grey.05f41976023f5e7e6e6171a7f791d5b1.svg";
export { ForwardRef as ReactComponent };